module.exports = __webpack_public_path__ + "static/img/gggggg_16.117a4d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/resources/images/icon/gggggg_16.png
// module id = XCjR
// module chunks = 1